export var ReleaseChannel;
(function (ReleaseChannel) {
    ReleaseChannel["Stable"] = "STABLE";
    ReleaseChannel["Beta"] = "BETA";
    ReleaseChannel["Alpha"] = "ALPHA";
})(ReleaseChannel || (ReleaseChannel = {}));
//# sourceMappingURL=release-channel.js.map